const GMSL_reg = [
-40.16889153503507,
-40.0830692324098,
-39.99724692978543,
-39.91142146798029,
-39.825599165355015,
-39.73977686272974,
-39.65395456010447,
-39.56813225747919,
-39.48230995485392,
-39.39648765222955,
-39.3106621904235,
-39.224839887799135,
-39.13901758517295,
-39.053195282548586,
-38.96737297992331,
-38.88155067729804,
-38.795725215492894,
-38.70990291286762,
-38.624080610242345,
-38.53825830761707,
-38.452436004991796,
-38.36661370236743,
-38.28079139974216,
-38.19496593793701,
-38.10914363531174,
-38.023321332686464,
-37.93749903006119,
-37.851676727435915,
-37.76585442481155,
-37.6800289630055,
-37.59420666038022,
-37.50838435775495,
-37.422562055130584,
-37.33673975250531,
-37.250917449880035,
-37.16509514725567,
-37.07926968544962,
-36.99344738282434,
-36.90762508019907,
-36.8218027775747,
-36.73598047494943,
-36.650158172324154,
-36.5643327105181,
-36.47851040789283,
-36.39268810526846,
-36.30686580264319,
-36.22104350001791,
-36.13522119739355,
-36.049398894768274,
-35.96357343296222,
-35.87775113033695,
-35.79192882771258,
-35.70610652508731,
-35.62028422246203,
-35.53446191983767,
-35.44863961721239,
-35.36281415540634,
-35.276991852781066,
-35.1911695501567,
-35.10534724753143,
-35.01952494490615,
-34.93370264228179,
-34.847877180475734,
-34.76205487785046,
-34.676232575225185,
-34.59041027260082,
-34.504587969975546,
-34.41876566735027,
-34.33294336472591,
-34.247117902918944,
-34.16129560029458,
-34.075473297669305,
-33.98965099504494,
-33.903828692419665,
-33.81800638979439,
-33.73218092798834,
-33.646358625363064,
-33.5605363227387,
-33.474714020113424,
-33.38889171748815,
-33.303069414863785,
-33.21724711223851,
-33.13142165043246,
-33.04559934780718,
-32.95977704518282,
-32.873954742557544,
-32.78813243993227,
-32.702310137307904,
-32.61648467550185,
-32.53066237287658,
-32.4448400702513,
-32.35901776762694,
-32.27319546500166,
-32.18737316237639,
-32.101550859751114,
-32.01572539794506,
-31.929903095320697,
-31.844080792695422,
-31.758258490071057,
-31.672436187445783,
-31.58661388482051,
-31.500791582195234,
-31.41496612038918,
-31.329143817764816,
-31.24332151513954,
-31.157499212514267,
-31.071676909888993,
-30.985854607263718,
-30.900029145458575,
-30.8142068428333,
-30.728384540208936,
-30.64279601695489,
-30.557207493700844,
-30.47161897044589,
-30.386030447191843,
-30.300441923938706,
-30.21485340068466,
-30.129264877430614,
-30.04367635417657,
-29.958087830922523,
-29.872499307668477,
-29.78691078441443,
-29.701322261160385,
-29.615736897087118,
-29.53014837383398,
-29.444559850579026,
-29.35897132732498,
-29.273382804070934,
-29.187794280816888,
-29.102205757562842,
-29.016617234309706,
-28.93102871105566,
-28.845440187801614,
-28.75985166454757,
-28.674263141293522,
-28.588674618039477,
-28.50308609478543,
-28.417500730712163,
-28.331912207458117,
-28.24632368420407,
-28.160735160950026,
-28.07514663769598,
-27.989558114441934,
-27.903969591187888,
-27.81838106793475,
-27.732792544680706,
-27.64720402142666,
-27.561596543087944,
-27.47577424046267,
-27.389951937838305,
-27.30412963521303,
-27.218307332587756,
-27.132481870781703,
-27.046659568157338,
-26.960837265532064,
-26.87501496290679,
-26.789192660282424,
-26.70337035765715,
-26.617548055031875,
-26.531722593225822,
-26.445900290600548,
-26.360077987976183,
-26.27425568535091,
-26.188433382726544,
-26.10261108010127,
-26.016785618295216,
-25.930963315669942,
-25.845141013044667,
-25.759318710420303,
-25.673496407795028,
-25.587674105169754,
-25.50185180254539,
-25.416026340739336,
-25.33020403811406,
-25.244381735488787,
-25.158559432864422,
-25.072737130239148,
-24.986914827613873,
-24.90108936580782,
-24.815267063183455,
-24.72944476055818,
-24.643622457932906,
-24.55780015530854,
-24.471977852683267,
-24.386155550057993,
-24.30033008825194,
-24.214507785626665,
-24.1286854830023,
-24.042863180377026,
-23.95704087775266,
-23.871218575127386,
-23.785396272502112,
-23.69957081069606,
-23.613748508070785,
-23.52792620544642,
-23.442103902821145,
-23.35628160019587,
-23.270459297570596,
-23.184633835765453,
-23.09881153314018,
-23.012989230514904,
-22.92716692789054,
-22.841344625265265,
-22.75552232263999,
-22.669700020014716,
-22.583874558209573,
-22.498052255584298,
-22.412229952959024,
-22.32640765033466,
-22.240585347708475,
-22.1547630450832,
-22.068937583278057,
-21.983115280653692,
-21.897292978028418,
-21.811470675403143,
-21.72564837277787,
-21.639826070152594,
-21.55400376752732,
-21.468178305722176,
-21.382356003096902,
-21.296533700472537,
-21.210711397847263,
-21.124889095221988,
-21.039066792596714,
-20.95324133079157,
-20.867419028166296,
-20.78159672554102,
-20.695774422915747,
-20.609952120290473,
-20.524129817665198,
-20.438307515040833,
-20.35248205323569,
-20.266659750610415,
-20.18083744798514,
-20.095015145359866,
-20.009192842734592,
-19.923370540109318,
-19.837548237484953,
-19.75172277567981,
-19.665900473053625,
-19.58007817042835,
-19.494255867803986,
-19.40843356517871,
-19.322611262553437,
-19.236785800748294,
-19.15096349812302,
-19.065141195497745,
-18.97931889287247,
-18.893496590248105,
-18.80767428762283,
-18.721851984997556,
-18.636026523192413,
-18.55020422056714,
-18.464381917941864,
-18.37855961531659,
-18.292737312691315,
-18.20691501006695,
-18.121089548260898,
-18.035422045490122,
-17.949833522236077,
-17.86424499898203,
-17.778656475727985,
-17.69306795247394,
-17.607479429219893,
-17.521890905965847,
-17.4363023827118,
-17.350713859457755,
-17.26512533620462,
-17.179536812950573,
-17.093948289695618,
-17.008359766441572,
-16.922771243187526,
-16.837185879115168,
-16.751597355860213,
-16.666008832606167,
-16.58042030935212,
-16.494831786098985,
-16.40924326284494,
-16.323654739590893,
-16.238066216336847,
-16.1524776930828,
-16.066889169828755,
-15.98130064657471,
-15.895712123320664,
-15.810123600066618,
-15.724535076812572,
-15.638949712739304,
-15.553361189485258,
-15.467772666231212,
-15.382184142977167,
-15.29659561972312,
-15.211007096469984,
-15.125418573215939,
-15.039830049961893,
-14.954241526707847,
-14.868479248515541,
-14.782656945891176,
-14.696834643265902,
-14.611012340640627,
-14.525190038015353,
-14.439367735390078,
-14.353542273584935,
-14.26771997095966,
-14.181897668335296,
-14.096075365710021,
-14.010253063084747,
-13.924430760459472,
-13.838608457834198,
-13.752782996029055,
-13.66696069340378,
-13.581138390778506,
-13.49531608815414,
-13.409493785527957,
-13.323671482902682,
-13.237849180278317,
-13.152023718473174,
-13.0662014158479,
-12.980379113222625,
-12.89455681059735,
-12.808734507972076,
-12.722912205346802,
-12.637086743541659,
-12.551264440917294,
-12.465442138292019,
-12.379619835666745,
-12.29379753304147,
-12.207975230416196,
-12.122152927790921,
-12.036327465985778,
-11.950505163360504,
-11.864682860735229,
-11.778860558109955,
-11.69303825548559,
-11.607215952860315,
-11.521390491055172,
-11.435568188429897,
-11.349745885804623,
-11.263923583179348,
-11.178101280554074,
-11.092278977929709,
-11.006456675304435,
-10.920631213499291,
-10.834808910874017,
-10.748986608247833,
-10.663164305623468,
-10.577342002998193,
-10.491519700372919,
-10.405694238567776,
-10.319871935942501,
-10.234049633317227,
-10.148227330691952,
-10.062405028067587,
-9.976582725442313,
-9.890760422817038,
-9.804934961011895,
-9.71911265838662,
-9.633290355761346,
-9.547468053136072,
-9.461645750511707,
-9.375823447886432,
-9.290001145261158,
-9.204175683455105,
-9.11835338082983,
-9.032531078205466,
-8.946708775580191,
-8.860886472955826,
-8.775064170330552,
-8.689238708524499,
-8.603416405899225,
-8.51759410327395,
-8.431771800649585,
-8.34594949802431,
-8.260127195399036,
-8.174304892774671,
-8.088479430968619,
-8.002657128343344,
-7.91683482571807,
-7.831012523093705,
-7.74519022046843,
-7.659367917843156,
-7.573542456037103,
-7.487720153412738,
-7.4018978507874635,
-7.316075548162189,
-7.230253245537824,
-7.14443094291255,
-7.058608640287275,
-6.972783178481222,
-6.8869608758568575,
-6.801138573231583,
-6.7153162706063085,
-6.629493967981944,
-6.543671665356669,
-6.457846203550616,
-6.372023900925342,
-6.286201598300067,
-6.2003792956757025,
-6.114556993050428,
-6.0287346904251535,
-5.942912387800789,
-5.857086925994736,
-5.771264623369461,
-5.685442320744187,
-5.599620018119822,
-5.5137977154945474,
-5.428044914844577,
-5.342459550771309,
-5.256871027517263,
-5.171282504263218,
-5.085693981009172,
-5.000105457755126,
-4.91451693450108,
-4.828928411247034,
-4.743339887993898,
-4.657751364739852,
-4.572162841485806,
-4.486574318230851,
-4.400985794976805,
-4.315397271722759,
-4.2298087484696225,
-4.144223384396355,
-4.0586348611414,
-3.9730463378882632,
-3.8874578146342174,
-3.8018692913801715,
-3.7162807681261256,
-3.6306922448720798,
-3.545103721618034,
-3.4595151983648975,
-3.373926675109942,
-3.2883381518558963,
-3.2027496286018504,
-3.1171611053478046,
-3.0315725820937587,
-2.945987218020491,
-2.8603986947664453,
-2.7748101715123994,
-2.689221648259263,
-2.603633125005217,
-2.5180446017511713,
-2.4324560784971254,
-2.3468675552430796,
-2.261187415749191,
-2.1753651131239167,
-2.0895396513187734,
-2.003717348693499,
-1.9178950460682245,
-1.83207274344295,
-1.7462504408176756,
-1.6604281381933106,
-1.5746058355680361,
-1.4887803737619834,
-1.402958071136709,
-1.3171357685114344,
-1.2313134658870695,
-1.145491163261795,
-1.05966886063743,
-0.9738433988313773,
-0.8880210962061028,
-0.8021987935808284,
-0.7163764909555539,
-0.6305541883311889,
-0.5447318857059145,
-0.45890958308064,
-0.37308412127458723,
-0.28726181865022227,
-0.2014395160249478,
-0.11561721339967335,
-0.02979491077530838,
0.05602739184996608,
0.14185285365601885,
0.2276751562812933,
0.3134974589056583,
0.39931976153093274,
0.4851420641562072,
0.5709643667805722,
0.6567866694058466,
0.7426121312118994,
0.8284344338371739,
0.9142567364615388,
1.0000790390868133,
1.0859013417120877,
1.1717236443364527,
1.257549106143415,
1.34337140876778,
1.4291937113930544,
1.5150160140183289,
1.6008383166426938,
1.6866606192679683,
1.7724829218932427,
1.8583083836992955,
1.9441306863236605,
2.029952988948935,
2.1157752915742094,
2.2015975941985744,
2.287419896823849,
2.3732421994491233,
2.459067661255176,
2.544889963879541,
2.6307122665048155,
2.71653456913009,
2.802356871754455,
2.8881791743797294,
2.974004636185782,
3.0598269388110566,
3.1456492414354216,
3.231471544060696,
3.3172938466859705,
3.4031161493103355,
3.4889384519365194,
3.660586216366937,
3.7464085189922116,
3.8322308216165766,
3.918053124241851,
4.0038754268671255,
4.089700888673178,
4.175523191297543,
4.261345493922818,
4.347167796548092,
4.432990099172457,
4.518812401797732,
4.604634704423006,
4.690460166229059,
4.776282468853424,
4.862104771478698,
4.947927074103973,
5.033749376729247,
5.119571679354522,
5.205397141159665,
5.291219443784939,
5.377041746409304,
5.462864049034579,
5.548686351659853,
5.634508654285128,
5.720330956910402,
5.806156418715545,
5.89197872134082,
5.977801023966094,
6.063623326590459,
6.149445629216643,
6.235267931841008,
6.321090234466283,
6.406915696271426,
6.4927379988967004,
6.578560301521975,
6.664382604147249,
6.750204906772524,
6.836027209397798,
6.921852671202942,
7.0076749738273065,
7.093497276452581,
7.1793195790778555,
7.264917579874236,
7.350506103128282,
7.43609146720155,
7.5216799904555955,
7.607268513709641,
7.692857036963687,
7.778445560216824,
7.8640340834708695,
7.949622606724915,
8.035211129978961,
8.120799653233007,
8.206388176487962,
8.291976699741099,
8.377565222995145,
8.46315374624919,
8.548742269503236,
8.634327633576504,
8.71991615683055,
8.805504680084596,
8.891093203338642,
8.976681726592687,
9.062270249845824,
9.14785877309987,
9.233447296353916,
9.319035819608871,
9.404624342862917,
9.490212866116963,
9.575801389370099,
9.661389912624145,
9.74697843587819,
9.832563799951458,
9.918152323205504,
10.00374084645955,
10.089329369713596,
10.174917892967642,
10.260506416221688,
10.346107576197937,
10.431929878823212,
10.517752181448486,
10.603574484072851,
10.689399945879813,
10.775222248504178,
10.861044551129453,
10.946866853753818,
11.032689156379092,
11.118511459004367,
11.204333761629641,
11.290159223435694,
11.375981526060059,
11.461803828685333,
11.547626131310608,
11.633448433934973,
11.719270736560247,
11.8050961983663,
11.890918500991575,
11.97674080361594,
12.062563106241214,
12.148385408866488,
12.234207711490853,
12.320030014116128,
12.40585547592218,
12.491677778547455,
12.57750008117182,
12.663322383797095,
12.749144686422369,
12.834966989047643,
12.920789291672918,
13.006614753478061,
13.092437056103336,
13.1782593587277,
13.264081661352975,
13.34990396397825,
13.435726266603524,
13.521551728409577,
13.607374031033942,
13.693196333659216,
13.77901863628449,
13.864840938909765,
13.95066324153504,
14.036485544159405,
14.122311005965457,
14.208133308589822,
14.293955611215097,
14.379777913840371,
14.465600216465646,
14.55142251909092,
14.637247980896063,
14.723070283521338,
14.808892586145703,
14.894714888770977,
14.980537191397161,
15.066359494021526,
15.1521817966468,
15.238007258451944,
15.323829561077218,
15.409651863702493,
15.495474166327767,
15.581296468953042,
15.667118771577407,
15.75294423338346,
15.838766536007824,
15.924588838633099,
16.010411141258373,
16.096233443883648,
16.182055746508922,
16.267878049133287,
16.35370351093934,
16.439525813564615,
16.52534811618989,
16.611170418815163,
16.69699272143953,
16.782815024064803,
16.868640485869946,
16.95446278849522,
17.040285091120495,
17.12610739374577,
17.211929696371044,
17.29775199899541,
17.383574301620683,
17.469399763425827,
17.55522206605201,
17.641044368676376,
17.72686667130165,
17.812688973926925,
17.89851127655129,
17.984333579176564,
18.070159040982617,
18.15598134360789,
18.241803646232256,
18.32762594885753,
18.413448251482805,
18.49927055410717,
18.585096015913223,
18.670918318538497,
18.75674062116377,
18.842562923789046,
18.92838522641341,
19.014207529038686,
19.10002983166305,
19.185855293470013,
19.271677596094378,
19.357499898719652,
19.443322201344927,
19.52914450396929,
19.614966806594566,
19.70079226840062,
19.786614571025893,
19.872291551339003,
19.95788007459305,
20.043468597847095,
20.12905712110023,
20.21464248517441,
20.300231008427545,
20.38581953168159,
20.471408054935637,
20.556996578189683,
20.64258510144373,
20.728173624697774,
20.81376214795182,
20.899350671205866,
20.984939194459912,
21.070527717713958,
21.156116240968004,
21.24170476422205,
21.327293287475186,
21.412878651549363,
21.49846717480341,
21.584055698056545,
21.66964422131059,
21.755232744564637,
21.840821267818683,
21.926409791073638,
22.011998314327684,
22.09758683758082,
22.183175360834866,
22.268763884088912,
22.354352407342958,
22.439940930597004,
22.52552629467027,
22.611114817924317,
22.696703341178363,
22.78229186443241,
22.867880387685545,
22.95346891093959,
23.03922487077034,
23.125047173395615,
23.21086947602089,
23.296691778646164,
23.382514081271438,
23.46833954307658,
23.554161845701856,
23.63998414832622,
23.725806450951495,
23.81162875357677,
23.897451056202044,
23.98327335882732,
24.069098820632462,
24.154921123257736,
24.24074342588301,
24.326565728508285,
24.41238803113356,
24.498210333757925,
24.5840326363832,
24.669858098188342,
24.755680400813617,
24.84150270343889,
24.927325006064166,
25.01314730868944,
25.098969611313805,
25.18479507311895,
25.270617375745132,
25.356439678370407,
25.442261980994772,
25.528084283620046,
25.61390658624532,
25.699728888869686,
25.78555435067574,
25.871376653301013,
25.957198955926287,
26.043021258550652,
26.128843561175927,
26.2146658638012,
26.300491325606345,
26.38631362823162,
26.472135930856894,
26.557958233482168,
26.643780536107442,
26.729602838731807,
26.815425141357082,
26.901250603163135,
26.98707290578841,
27.072895208412774,
27.15871751103805,
27.244539813663323,
27.330362116287688,
27.41618757809374,
27.502009880719015,
27.58783218334429,
27.673654485968655,
27.75947678859393,
27.845299091219204,
27.93112139384357,
28.01694685564962,
28.102769158274896,
28.18859146090017,
28.274413763524535,
28.36023606614981,
28.446058368775084,
28.53188067139945,
28.61770613320641,
28.703528435830776,
28.78935073845605,
28.875173041081325,
28.96099534370569,
29.046817646330965,
29.132643108137017,
29.218465410762292,
29.304287713386657,
29.39011001601193,
29.475932318637206,
29.56175462126157,
29.647576923886845,
29.733402385692898,
29.819224688318172,
29.905046990942537,
29.990869293567812,
30.076691596193086,
30.16251389881745,
30.248339360623504,
30.33416166324878,
30.419983965874053,
30.505806268498418,
30.591628571123692,
30.677450873748967,
30.76327317637424,
30.849098638180294,
30.93492094080466,
31.020743243429934,
31.1065655460543,
31.192387848679573,
31.278210151304847,
31.3640356131109,
31.449857915736175,
31.53568021836054,
31.621502520985814,
31.70732482361109,
31.793147126235453,
31.878969428861637,
31.96479489066678,
32.050617193292055,
32.13643949591642,
32.222261798541695,
32.30808410116697,
32.39390640379224,
32.47966552280377,
32.56525404605782,
32.65084256931095,
32.736431092565,
32.822019615819045,
32.90760497989231,
32.99319350314636,
33.078782026400404,
33.16437054965445,
33.249959072908496,
33.33554759616254,
33.42113611941659,
33.50672464267063,
33.59231316592468,
33.677901689178725,
33.76349021243277,
33.84907873568591,
33.93466725893995,
34.020255782194,
34.10584114626727,
34.19142966952131,
34.27701819277536,
34.362606716029404,
34.44819523928345,
34.533783762537496,
34.61937228579154,
34.70496080904559,
34.79054933229963,
34.87613785555368,
34.961726378807725,
35.04731490206177,
35.13290342531491,
35.21849194856895,
35.30407731264313,
35.38966583589627,
35.47525435915031,
35.56084288240436,
35.6465167035376,
35.73234216534365,
35.81816446796802,
35.90398677059329,
35.98980907321857,
36.07563137584293,
36.161453678468206,
36.24727598109348,
36.33310144289953,
36.41892374552481,
36.50474604814917,
36.59056835077445,
36.67639065339881,
36.76221295602409,
36.84803841783014,
36.933860720455414,
37.01968302308069,
37.10550532570505,
37.19132762833033,
37.2771499309556,
37.36297223357997,
37.44879769538602,
37.534619998011294,
37.62044230063657,
37.706264603260934,
37.79208690588621,
37.87790920851148,
37.963734670317535,
38.0495569729419,
38.135379275567175,
38.22120157819245,
38.307023880816814,
38.39284618344209,
38.47866848606736,
38.564493947873416,
38.65031625049869,
38.736138553123055,
38.82196085574833,
38.907783158372695,
38.99360546099797,
39.07943092280402,
39.165253225429296,
39.25107552805457,
39.336897830678936,
39.42272013330421,
39.508542435929485,
39.59436473855476,
39.6801902003599,
39.76601250298518,
39.85183480561045,
39.937657108234816,
40.02347941086009,
40.109301713485365,
40.19512401611064,
40.28094947791578,
40.36677178054106,
40.45259408316633,
40.5384163857907,
40.62423868841597,
40.710060991042155,
40.7958864528473,
40.88170875547257,
40.96753105809694,
41.05335336072221,
41.13917566334749,
41.22499796597276,
41.310820268598036,
41.39664573040318,
41.482468033028454,
41.56829033565282,
41.65411263827809,
41.73993494090337,
41.82575724352864,
41.911582705333785,
41.99740500795906,
42.083227310584334,
42.16904961320961,
42.25487191583488,
42.34069421846016,
42.42651652108452,
42.512341982889666,
42.59816428551494,
42.683986588140215,
42.76980889076549,
42.855631193390764,
42.94145349601604,
43.02727895782118,
43.113101260445546,
43.19892356307082,
43.284745865696095,
43.37056816832137,
43.456390470946644,
43.54221277357192,
43.62803823537706,
43.713860538002336,
43.79968284062761,
43.885505143252885,
43.97132744587816,
44.057149748502525,
44.1429720511278,
44.22879751293294,
44.31461981555822,
44.40044211818349,
44.486264420808766,
44.57208672343404,
44.657909026058405,
44.74373448786446,
44.82955679048973,
44.91537909311501,
45.00120139573937,
45.087023698364646,
45.172628017521674,
45.25821654077572,
45.343805064029766,
45.42939358728381,
45.51498211053786,
45.600570633791904,
45.68615599786517,
45.77174452111922,
45.85733304437326,
45.94292156762731,
46.028510090881355,
46.1140986141354,
46.199687137389446,
46.28527566064349,
46.37086418389663,
46.456452707150675,
46.54204123040472,
46.627629753658766,
46.71321827691281,
46.79880680016686,
46.884392164240126,
46.96998068749417,
47.05556921074822,
47.14115773400226,
47.22674625725631,
47.312334780510355,
47.3979233037644,
47.48351182701845,
47.56910035027249,
47.65468887352563,
47.740277396779675,
47.82586592003372,
47.91145444328777,
47.99704296654272,
48.08262833061508,
48.168216853869126,
48.25381169548473,
48.33963399810909,
48.42545630073528,
48.51128176254042,
48.597104065165695,
48.68292636779006,
48.768748670415334,
48.85457097304061,
48.94039327566588,
49.02621557829116,
49.1120410400963,
49.197863342721575,
49.28368564534685,
49.369507947971215,
49.45533025059649,
49.541152553221764,
49.62697801502782,
49.71280031765218,
49.798622620277456,
49.88444492290273,
49.970267225528005,
50.05608952815328,
50.141911830778554,
50.2277372925837,
50.31355959520806,
50.39938189783334,
50.48520420045861,
50.571026503083885,
50.65684880570916,
50.742671108334434,
50.82849657013958,
50.91431887276394,
51.00014117539013,
51.0859634780154,
51.171785780639766,
51.25760808326504,
51.343433545070184,
51.42925584769546,
51.51507815032073,
51.60090045294601,
51.68672275557128,
51.77254505819565,
51.85836736082092,
51.944192822626064,
52.03001512525134,
52.11583742787661,
52.20165973050189,
52.28748203312716,
52.37330433575244,
52.45912979755758,
52.544952100182854,
52.63077440280813,
52.7165967054334,
52.80241900805777,
52.88824131068304,
52.97406361330832,
53.05988907511346,
53.145711377738735,
53.23153368036401
]

export default GMSL_reg